import React from 'react';
import { useRecoilState } from 'recoil';
import { defaultIsMobile } from '../../../../../../utils/states/isMobile.state';

import DisputesBlocks from './components/Blocks/DisputesBlocks';
import DisputesTable from './components/Table/DisputesTable';

export const Content: React.FC = () => {
  const [version] = useRecoilState(defaultIsMobile);
  const isMobile = version.isMobile;

  return (
    <div>
      {isMobile ? <DisputesBlocks /> : <DisputesTable />}
    </div>
  );
};

export default Content;
